<template>
  <div class="relative mb-4">
    <label
      v-if="label"
      class="absolute left-4 -top-0 bg-white px-2 text-gray-400 text-xs font-semibold pointer-events-none"
      style="transform: translateY(-50%);"
    >
      {{ label }}
    </label>
    <vue-tel-input
    ref="vueTelInput"
    @country-changed="countryChanged"
    @input="handleInput"
      :disabled="disabled"
      :inputOptions="{
        showDialCode: true,
      }"
      :enabledCountryCode="true"
      :preferredCountries="['IT', 'CH', 'FR', 'DE', 'GB', 'US']"
      :wrapper-classes="[
        'w-full',
        'rounded-full',
        'border',
        danger ? 'border-red-500 focus:ring-red-500' : 'border-gray-200 focus:ring-primary',
        'px-5 p-3',
        'focus:outline-none focus:ring-2 transition',
        loading ? 'opacity-60 pointer-events-none' : ''
      ]"
      :input-classes="[
        'text-base',
        'font-comfortaa',
        'bg-transparent',
        'w-full',
      ]"
      :style="{
        background: disabled ? '#f9fafb' : 'white'
      }"
      :placeholder="'Inserisci il numero di telefono'"
    />
    <!-- show red message if not valid-->
    <div class="text-red-500 text-sm mt-1" v-if="invalid && tempValue.length > 0">
      Numero di telefono non valido
    </div>
    <div v-if="loading" class="absolute right-4 top-1/2 transform -translate-y-1/2">
      <svg class="animate-spin h-5 w-5 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </div>
  </div>
</template>

<script>

export default {
  name: "CuPhoneInput",
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    danger: { type: Boolean, default: false }
  },
  data() {
    return {
      inputValue: this.value,
      tempValue: "",
      invalid: false
    };
  },
  watch: {
    
    inputValue(n) {
      this.$emit("input", n);
    }
  },
  mounted(){
    console.log(this.$refs.vueTelInput);
  },
  methods: {
    handleInput(phone, obj) {
      console.log(obj);
      if(obj.valid){
        console.log('Input value changed:', obj.number);
        this.inputValue = obj.number;
        this.invalid = false;
      } else {
        if(obj.nationalNumber && obj.nationalNumber.length > 0){ // do not show error if input is empty
          this.invalid = true;
        } else {
          this.invalid = false;
        }
        this.inputValue = null;
      }
      this.tempValue = phone;
    },

    countryChanged(){
      console.log('Country changed:', this.$refs.vueTelInput.country);
      if(this.value){
        this.$refs.vueTelInput.phone = this.value;
      }
    }
  }
};
</script>
<style>
.vue-tel-input {
  margin-bottom: 0!important;
}
</style>
<style scoped>
/* Match the main wrapper to CuInput */
::v-deep .vue-tel-input {
  border-radius: 9999px !important; /* rounded-full */
  border: 1px solid #e5e7eb !important; /* border-gray-200 */
  padding: 0.5rem 0.5rem !important;
  background: white !important;
  width: 100% !important;
  box-shadow: none !important;
  transition: box-shadow 0.2s, border-color 0.2s;
  font-family: 'Comfortaa', Arial, sans-serif !important;
  font-size: 1rem !important;
}
::v-deep .vue-tel-input.disabled {
  background: #f9fafb !important; /* bg-gray-100 */
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  opacity: 1 !important;
}
::v-deep .vue-tel-input:focus-within {
  border-color: var(--color-primary, #F28C3A) !important;
  box-shadow: 0 0 0 2px var(--color-primary, #F28C3A, 0.2) !important;
}
::v-deep .vti__input {
  border: none !important;
  background: transparent !important;
  font-family: 'Comfortaa', Arial, sans-serif !important;
  font-size: 1rem !important;
  padding: 0 !important;
  color: #222 !important;
  box-shadow: none !important;
}
::v-deep .vti__dropdown {
  border-radius: 9999px !important;
  border: none !important;
  background: transparent !important;
}
::v-deep .vti__flag {
  margin-right: 0.5rem !important;
}
::v-deep .vti__selection {
  border-radius: 9999px !important;
  background: transparent !important;
}
::v-deep .vti__input[disabled] {
  background: #f9fafb !important;
  color: #bdbdbd !important;
}
</style>
